import React, { useState } from "react";
import { Modal, ModalBody, ModalHeader } from "reactstrap";

export default function BannerRibbon(props) {
    console.log(props.text,"props11")
    const [showPopup, setShowPopup] = useState(false);
   
    const toggle = () => {
        setShowPopup(!showPopup);
    }

    return (
        <div className="ribbon">
            <p className="ribbon-text">
                {props.text}
                {props.text?.trim().toLowerCase() == "anytime liquidity" ?
                    <span onClick={toggle} className="ml-1 cursor-pointer">
                        <i className="mdi mdi-information-outline" /></span> :
                    null}               
            </p>
            <Modal isOpen={showPopup} toggle={toggle} centered>
                <ModalHeader className="pb-0" toggle={toggle} style={{border: "none"}}/>
                <ModalBody className="text-center pt-2">
                    {/* <p dangerouslySetInnerHTML={{__html: props.text}} /> */}
                    <p>Liquidity will be provided at a Fee of 2%. Refer to FAQs for more details.</p>
                </ModalBody>
            </Modal>
        </div>
    )
}